import React from "react";
import {useTranslation} from "react-i18next";
import EditIcon from '@mui/icons-material/Edit';
import {PrimaryButton} from "./PrimaryButton";
import {SxProps} from "@mui/system";
import {Theme} from "@mui/material/styles";

export function EditButton(props: {
  onClick: () => void,
  disabled?: boolean,
  title?: string,
  sx?: SxProps<Theme>;
}) {
  const {t} = useTranslation();
  return (
    <PrimaryButton sx={props.sx} onClick={props.onClick} startIcon={<EditIcon/>} title={props.title || t('buttons.edit')}
                   disabled={props.disabled}/>
  )
}
